import { v4 as uuidv4 } from 'uuid';

export const SCORE_MIN = 300;
export const SCORE_MAX = 850;

// eslint-disable-next-line import/prefer-default-export
export const BLOCKS = [
  {
    id: uuidv4(),
    label: 'Poor',
    color: '#ef6023',
  },
  {
    id: uuidv4(),
    label: '',
    color: '#f68e20',
  },
  {
    id: uuidv4(),
    label: '',
    color: '#facc0c',
  },
  {
    id: uuidv4(),
    label: '',
    color: '#7dbb42',
  },
  {
    id: uuidv4(),
    label: '',
    rightLabel: 'Excellent',
    color: '#2a9245',
  },
];
